var map = {
	"./boolando.png": "5f80",
	"./boolflix-ok.png": "992c",
	"./boolstrap.png": "1440",
	"./boolzapp.png": "9088",
	"./dc-comics.png": "cccf",
	"./deliveboo-1.png": "3154",
	"./deliveboo-2.png": "7d23",
	"./dropbox.png": "f64a",
	"./logistic-1.png": "d96c",
	"./logistic-2.png": "6a31",
	"./logo.png": "cf05",
	"./me-prova.png": "fc90",
	"./me.png": "9f2c",
	"./mia-foto.png": "4dcb",
	"./patrick.png": "8063",
	"./playstation-1.png": "561e",
	"./playstation-2.png": "76ff",
	"./rick-morty.png": "b919",
	"./schermata.png": "250b",
	"./spotify-web.png": "fd83",
	"./vue-dischi.png": "beb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";